import { lazy } from "react";
import Loadable from "components/Loadable";
// const ForgotPassword = Loadable(lazy(() => import("pages/sessions/forgot/ForgotPassword")));


const ForgotPassword = Loadable(lazy(() => import("pages/sessions/forgot/ForgotPassword")));
const Login = Loadable(lazy(() => import("pages/sessions/login/Login")));
const Register = Loadable(lazy(() => import("pages/sessions/register/Register")));
const ResetPassword = Loadable(lazy(() => import("pages/sessions/reset/ResetPassword")));


const sessionRoutes = [
  { path: "/session/signup", element: <Register /> },
  { path: "/session/signin", element: <Login /> },
   { path: "/session/forgot-password", element: <ForgotPassword /> },
  { path: "/session/reset-password", element: <ResetPassword /> },
];

export default sessionRoutes;
